import { GtmSdk } from "..";

const mock = {
  push: () => {
    throw new Error("cannot call on server");
  },
};
export const createGtmInstance = (): GtmSdk => {
  return new GtmSdk(
    typeof window !== "undefined" ? (window?.dataLayer ?? mock) : mock,
  );
};
